var ondemand_player;
var countriesCountDatatable;
mojoD = {
    closeDemandVideo: function(get_player){
        $( '#demand-modal' ).on( 'hide.bs.modal', function() {
            var modalBody = $('#demand-modal .modal-body');
            if (get_player === 'jwplayer7' || get_player === 'jwplayer8') {
                ondemand_player.remove();
            }
            else {
                if(get_player === 'videojs' || get_player === 'wowza'){
                    ondemand_player.dispose();
                    modalBody.append('<video id="videojs" style="width: 100%;" class="video-js vjs-default-skin"><source src="" type="application/x-mpegURL"></video>');
                }else{
                    ondemand_player.destroy();
                    if(get_player === 'fluidplayer'){
                        // FluidPlayer wraps the video in a container - clean it up
                        $('#fluid_video_wrapper_fluidPlayer').remove();
                        modalBody.append('<video id="fluidPlayer" style="height: 100%; width: 100%;"><source src="" type="application/x-mpegURL"></video>');
                    }
                }
            }
        });
    },

    initColorSchema: function(){
        $().ready(function() {
            $navbar = $('.navbar');
            $main_panel = $('.main-panel');
            footer = $('.ondemand-footer');
            white_color = false;
            options = mojoD.getColorSchema();
            var theme_color = 'dark';
            var buttons_color = 'primary';
            // loop
            $.each(
                options, function( k, v ) {
                    if ( v == null ) return;
                    theme_color =  v.theme_color;
                    buttons_color = v.buttons_color;
                }
            );
            fixed_plugin_open = $('.sidebar .sidebar-wrapper .nav li.active a p').html();

            $('.fixed-plugin a').click(function(event) {
                if(theme_color == 'white' && $('body').hasClass('white-content')){
                    white_color = true;
                    if($('.bootstrap-switch-id-themecolor').hasClass('bootstrap-switch-on')){
                        $('.bootstrap-switch-id-themecolor').removeClass('bootstrap-switch-on');
                        $('.bootstrap-switch-id-themecolor').addClass('bootstrap-switch-off');
                    }
                }

                if(theme_color == 'black' && !$('body').hasClass('white-content')){
                    white_color = false;
                    if($('.bootstrap-switch-id-themecolor').hasClass('bootstrap-switch-off')){
                        $('.bootstrap-switch-id-themecolor').removeClass('bootstrap-switch-off');
                        $('.bootstrap-switch-id-themecolor').addClass('bootstrap-switch-on');
                    }
                }

                if ($(this).hasClass('switch-trigger')) {
                    if (event.stopPropagation) {
                        event.stopPropagation();
                    } else if (window.event) {
                        window.event.cancelBubble = true;
                    }
                }
            });

            $('.fixed-plugin .background-color span').click(function() {
                $(this).siblings().removeClass('active');
                $(this).addClass('active');

                var new_color = $(this).data('color');

                if ($main_panel.length != 0) {
                    $main_panel.attr('data', new_color);
                    footer.attr('data', new_color);
                }

                mojoD.saveColorSchema([{theme_color: theme_color, buttons_color: new_color}]);
            });

            $('.switch-change-color input').on("switchChange.bootstrapSwitch", function() {
                var $btn = $(this);

                if (white_color == true) {

                    $('body').addClass('change-background');
                    setTimeout(function() {
                        $('body').removeClass('change-background');
                        $('body').removeClass('white-content');
                    }, 900);
                    white_color = false;
                    mojoD.saveColorSchema([{theme_color: 'dark', buttons_color: buttons_color}])
                } else {

                    $('body').addClass('change-background');
                    setTimeout(function() {
                        $('body').removeClass('change-background');
                        $('body').addClass('white-content');
                    }, 900);

                    white_color = true;
                    mojoD.saveColorSchema([{theme_color: 'white', buttons_color: buttons_color}])
                }
            });

            $('.light-badge').click(function() {
                $('body').addClass('white-content');
                theme_color = 'white';
                mojoD.saveColorSchema([{theme_color: theme_color, buttons_color: buttons_color}])
            });

            $('.dark-badge').click(function() {
                $('body').removeClass('white-content');
                theme_color = 'dark';
                mojoD.saveColorSchema([{theme_color: theme_color, buttons_color: buttons_color}])
            });
        });
    },

    saveColorSchema: function(options){
        var tmpOpt = $.getCookie( 'themeColor' );
        options = options || [];

        if(tmpOpt){

        }

        $.addCookie( 'themeColor', JSON.stringify( options ), 365, "/" );
    },

    getColorSchema: function(){
        // Get list from cookie =)
        var options = $.getCookie( 'themeColor' );

        // If cookie doesn't exit
        if ( typeof (options) === 'undefined' || options === null ) {

            return [];

        } else {

            try {

                options = JSON.parse( options );

            } catch ( e ) {

                // Log error to console
                console.log( e );

            }

            // Make sure we got array
            if ( options !== null && options.length >= 1 ) {

                return options;

            } else {

                return [];
            }

        }
    },

    appendColorSchema: function(){
        var options = mojoD.getColorSchema();

        $navbar = $('.navbar');
        $main_panel = $('.main-panel');
        footer = $('.ondemand-footer');

        $full_page = $('.full-page');
        // loop
        $.each(
            options, function( k, v ) {
                if ( v == null ) return;

                if ($main_panel.length != 0) {
                    $main_panel.attr('data', v.buttons_color);
                    footer.attr('data', v.buttons_color);
                }

                if ($full_page.length != 0) {
                    $full_page.attr('filter-color', v.buttons_color);
                }

                if(v.theme_color == 'white' && !$('body').hasClass('white-content')){
                    $('body').addClass('white-content');
                }

                if(v.theme_color == 'black' && $('body').hasClass('white-content')){
                    $('body').removeClass('white-content');
                }
            }
        );
        return [];
    },

    updateGeoData: function(url){
        $.getJSON( url ).done( function( rsp ) {

            mojoD.initVectorMap(rsp.geoData);
        });
    },

    _flagsPreloaded: false,

    _preloadFlags: function() {
        if (mojoD._flagsPreloaded) return;
        mojoD._flagsPreloaded = true;
        var tpl = $('meta[name="template"]').attr('content') || 'modern';
        var basePath = '/templates/' + tpl + '/assets/img/flags/';
        var mapData = jvm.Map.maps['world_mill_en'];
        if (mapData && mapData.paths) {
            Object.keys(mapData.paths).forEach(function(code) {
                new Image().src = basePath + code.toLowerCase() + '.svg';
            });
        }
        new Image().src = basePath + 'unknown.svg';
    },

    _buildMapTooltip: function(flag, name, count) {
        var tpl = $('meta[name="template"]').attr('content') || 'modern';
        return '<div class="jvectormap-tip-content">' +
            '<img src="/templates/' + tpl + '/assets/img/flags/' + flag + '.svg" class="jvectormap-tip-flag" alt="' + name + '">' +
            '<span class="jvectormap-tip-name">' + name + '</span>' +
            '<span class="jvectormap-tip-badge"><i class="fa-solid fa-user"></i> ' + count + '</span>' +
        '</div>';
    },

    /**
     * Keep only markers with valid coordinates (drops Unknown geo-IP entries).
     * Backend sends markers either as an array or an iso-keyed object.
     */
    _filterValidMarkers: function(markers) {
        // NOTE: do not use isFinite() here - it coerces (isFinite(null) and
        // isFinite("") are both true), which lets MaxMind rows with no
        // city-level coords (latLng [null,null]) through to jVectorMap and
        // projects them to NaN -> "<circle> attribute cy: Expected length, NaN".
        var isNum = function(v) {
            if (v === null || v === '' || typeof v === 'boolean') return false;
            var n = (typeof v === 'number') ? v : Number(v);
            return Number.isFinite(n);
        };
        var hasCoords = function(m) {
            return m && Array.isArray(m.latLng) && isNum(m.latLng[0]) && isNum(m.latLng[1]);
        };
        if (Array.isArray(markers)) {
            return markers.filter(hasCoords);
        }
        if (markers && typeof markers === 'object') {
            var valid = {};
            for (var k in markers) {
                if (markers.hasOwnProperty(k) && hasCoords(markers[k])) {
                    valid[k] = markers[k];
                }
            }
            return valid;
        }
        return [];
    },

    initVectorMap: function(mapData) {
        if(!mapData){
            return false;
        }

        mojoD._preloadFlags();
        const { countries, general_count } = mapData;
        var tpl = $('meta[name="template"]').attr('content') || 'modern';

        // Build ISO-keyed lookup (countries may be an array or object with non-ISO keys)
        var countryByIso = {};

        // Datatables for countries
        const table_countries = $('#countries_count').DataTable({ retrieve: true, searching: false, info: false,
            dom: 'rtip', bSort: false,
            "language": {
                "emptyTable": "You don't have any data!"
            }
        });

        // Clear countries table
        table_countries.clear();

        if($(countries).length > 0)
        {
            for (const key in countries) {
                const country = countries[key];

                let name = country['name'];
                // Use the iso field if available, otherwise use the key itself
                let iso = country['iso'] || key;
                let flag = iso;
                if(!name || name === "Unknown" || name === "Null" || name === "null"){
                    flag = "unknown";
                    name = "Unknown";
                }

                // Store in lookup for map tooltips
                countryByIso[iso] = { name: name, count: country['count'] || 0 };

                table_countries.row.add([
                    `<span class="flag"><img src="/templates/${tpl}/assets/img/flags/${flag}.svg" alt="${name}"></span>`,
                    name,
                    country['count'],
                    ((country['count'] * 100) / general_count).toFixed(2) + "%"
                ]);
            }
        }

        // Redraw countries table
        table_countries.draw(false);

        // Clear World Map
        $('#worldMap').empty();

        // Filter out markers with invalid coordinates (Unknown geo-IP entries)
        var validMarkers = mojoD._filterValidMarkers(countries);

        $('#worldMap').vectorMap({
            map: 'world_mill_en',
            backgroundColor: "transparent",
            zoomOnScroll: false,
            regionStyle: {
                initial: {
                    fill: '#f0f5ff',
                    "fill-opacity": 1,
                    stroke: '#e8eef8',
                    "stroke-width": 0.5,
                    "stroke-opacity": 1
                },
                hover: {
                    fill: '#e0e9f6',
                    "fill-opacity": 1,
                    cursor: 'default'
                }
            },
            markerStyle: {
                initial: {
                    fill: '#5d87ff',
                    stroke: '#fff',
                    "stroke-width": 1.5,
                    r: 5
                },
                hover: {
                    fill: '#49beff',
                    stroke: '#fff',
                    "stroke-width": 2,
                    r: 7
                }
            },
            markers: validMarkers,
            onRegionTipShow: function(e, tip, code) {
                var iso = code.toLowerCase();
                var data = countryByIso[iso];
                var name = tip.text();
                var count = data ? data.count : 0;
                tip.html(mojoD._buildMapTooltip(iso, name, count));
            },
            onMarkerTipShow: function(e, tip, index) {
                var country = validMarkers[index];
                if (!country) return;
                var name = country.name || tip.text();
                var count = country.count || 0;
                var iso = country.iso || index;
                var flag = iso;
                if (!name || name === 'Unknown' || name === 'Null' || name === 'null') {
                    flag = 'unknown';
                    name = 'Unknown';
                }
                tip.html(mojoD._buildMapTooltip(flag, name, count));
            },
        });
    },

    initFullCalendar: function(domain, id, start_date = '') {
        // Load via AJAX
        var table = $('#dayCalendarTable');
        var url = domain + '/tvpage-schedule/' + id + '/playlists';
        if(start_date){
            url = domain + '/tvpage-schedule/' + id + '/playlists/' + start_date;
        }

        $.getJSON( url, function( resp ) {
            if(resp.playlists) {
                $(table).find('tbody').find('tr').remove();
                var playlist = {};

                const clientTimezone = moment.tz.guess();
                //console.log(resp.playlists.length);
                for (let i = 0; i < Object.keys(resp.playlists).length; i++) {

                    if (typeof resp.playlists[i] !== "undefined") {
                        var playlist_options = resp.playlists[i].video;

                        $.each(playlist_options, function (i, video) {
                            const timezone = video.media_server_timezone;

                            let media_start = moment.tz(video.start_timestamp, timezone);
                            let media_end = moment.tz(video.end_time, timezone);

                            let start = media_start.clone().tz(clientTimezone).format('HH:mm:ss');

                            let duration = video.duration;
                            let [hours, minutes, seconds] = duration.split(':').map(Number);
                            let duration_milliseconds =
                                (hours * 60 * 60 * 1000) + // Convert hours to milliseconds
                                (minutes * 60 * 1000) +   // Convert minutes to milliseconds
                                (seconds * 1000);

                            var start_sec = media_start.clone().tz(clientTimezone).valueOf();
                            var end_sec =  start_sec + duration_milliseconds;


                            playlist[i] = {name: video.name, start:start, start_sec:start_sec, end_sec:end_sec, domain: domain, id: id};
                        });
                    }
                }

                var table_html = '';
                var air_index = '';
                var index = 0;
                $.each(playlist, function (ii, item) {
                    var current_timestamp = new Date().getTime();

                    table_html += "<tr>\n";
                    table_html += "<td>";

                    if(item.start_sec <= current_timestamp && item.end_sec >= current_timestamp){
                        air_index = index;
                        table_html += "<span class='schedule_on_air'>ON NOW</span><br />";
                    }

                    if(index - 1 === air_index){
                        table_html += "<span class='schedule_on_air'>UP TO NEXT</span><br />";
                    }


                    table_html += "<span class='schedule_start_time'>" + item.start + "</span></td>\n";
                    table_html += "<td>" + item.name;
                    if(item.start_sec <= current_timestamp && item.end_sec >= current_timestamp) {
                        table_html += "<br /><div class='record_link mobile_link'><a  href='" + item.domain + "/tvpage/" + item.id + "/play'><span class='record_circle'></span>WATCH NOW</a></div>";
                    }
                    table_html += "</td>\n";
                    table_html += "<td>";
                    if(item.start_sec <= current_timestamp && item.end_sec >= current_timestamp){
                        table_html += "<div class='record_link desctop_link'><a  href='" + item.domain + "/tvpage/" + item.id + "/play'><span class='record_circle'></span>WATCH NOW ON LIVE TV</a></div></td>\n";
                    }
                    table_html += "</td>";
                    table_html += "</tr>";

                    index++;
                });

                if(table_html !== ''){
                    $(table).find('tbody').append(table_html);
                }
            }
        })
    },

    generateDates: function(domain, id){
        var merge_array = mojoD.timeFrom(-31, 31);
        var slider_wrap = $('#daysSlider');
        var html = '';
        var today = new Date().toDateString();
        html += '<div class="splide__track">';
        html += '<ul class="splide__list" id="tv_splide_list">';
        var unique = [];
        $.each(merge_array, function(i, el){
            if($.inArray(el, unique) === -1) unique.push(el);
        });

        var index = 0;
        $.each(unique, function (ii, item) {
            if(today === item){
                index = ii;
                html += '<li class="splide__slide is-today"><div class="splide__slide__container">';
            }else{
                html += '<li class="splide__slide"><div class="splide__slide__container">';
            }
            var data = new Date(item);
            var month = data.getMonth() + 1;
            if(month < 10){
                month = '0' + month;
            }
            var day = data.getDate();
            if(day < 10){
                day = '0' + day;
            }
            var start_date = data.getFullYear() + "-" + month + "-" + day;
            html += '<a href="#" data-start="' + start_date + '" data-domain = "' + domain + '" data-id = "' + id + '" onclick="mojoD.changeDate(this)">' + item + '</a>';
            html += '</div></li>';
        });

        $(slider_wrap).append(html);

        var splide = new Splide( '#daysSlider', {
            type   : 'loop',
            perPage: 7,
            focus  : 'center',
            perMove: 1,
            // padding: 2,
            pagination: false,
            start: index,
            breakpoints: {
                '1130':{perPage: 5},
                '920':{perPage: 4},
                '780':{perPage: 3},
                '720':{perPage: 1}
            }
        });

        splide.mount();

        splide.on( 'moved', function () {
            var current_li = $('#daysSlider').find('li.is-active');
            var link = current_li.find('a')[0];
            var domain = $(link).attr('data-domain');
            var id = $(link).attr('data-id');
            var start = $(link).attr('data-start');

            //Rebuild table
            mojoD.initFullCalendar(domain, id, start);
        });

        var current_li = $('#daysSlider').find('li.is-active');
        var link = current_li.find('a')[0];
        var domain = $(link).attr('data-domain');
        var id = $(link).attr('data-id');
        var start = $(link).attr('data-start');

        //Rebuild table
        // mojoD.initFullCalendar(domain, id, start);
    },

    changeDate: function(elem){
        var domain = $(elem).attr('data-domain');
        var id = $(elem).attr('data-id');
        var start = $(elem).attr('data-start');
        var sliders = $('.splide__slide');

        //Remove active class
        $.each(sliders, function (ii, item) {
            if($(item).hasClass('is-active')){
                $(item).removeClass('is-active');
            }
        });

        //Add active class to current elem
        $(elem).parent().parent().addClass('is-active');

        //Rebuild table
        mojoD.initFullCalendar(domain, id, start);
    },

    timeFrom: function(X,Y){
        var dates = {};
        for (let I = 0; I < Math.abs(X); I++) {
            var key = new Date(new Date().getTime() - ((X >= 0 ? I : (I - I - I)) * 24 * 60 * 60 * 1000)).getTime();
            var date = new Date(new Date().getTime() - ((X >= 0 ? I : (I - I - I)) * 24 * 60 * 60 * 1000)).toDateString();
            dates[key] = date;
            // dates.push(new Date(new Date().getTime() - ((X >= 0 ? I : (I - I - I)) * 24 * 60 * 60 * 1000)).toDateString());
        }

        for (let J = 0; J < Math.abs(Y); J++) {
            var j_key = new Date(new Date().getTime() - ((Y >= 0 ? J : (J - J - J)) * 24 * 60 * 60 * 1000)).getTime();
            var j_date = new Date(new Date().getTime() - ((Y >= 0 ? J : (J - J - J)) * 24 * 60 * 60 * 1000)).toDateString();
            dates[j_key] = j_date;

            // dates.push(new Date(new Date().getTime() - ((Y >= 0 ? J : (J - J - J)) * 24 * 60 * 60 * 1000)).toDateString());
        }

        const ordered = Object.keys(dates).sort().reduce(
            (obj, key) => {
                obj[key] = dates[key];
                return obj;
            },
            {}
        );

        return Object.values(ordered);
    }
};